// extracted by mini-css-extract-plugin
module.exports = {"Page":"pages-module--Page--38p49","content_container":"pages-module--content_container--3PgYv","error_container":"pages-module--error_container--1tmqA"};